// ITEM 목록 불러오기
export const RECEIVE_ITEMS = "POST_RECEIVE_ITEMS";

// ITEM 클리어
export const CLEAR_ITEMS = "POST_CLEAR_ITEMS";

// 키워드 검색
export const SEARCH_KEYWORD = "POST_SEARCH_KEYWORD";

// 하나의 ITEM 선택 (체크박스)
export const SELECT_ITEM = "POST_SELECT_ITEM";

// 하나의 ITEM 선택 해제 (체크박스)
export const DESELECT_ITEM = "POST_DESELECT_ITEM";

// 모든 ITEM 선택 (전체선택) (리스트의 ITEM 체크)
export const SELECT_ALL_ITEMS = "POST_SELECT_ALL_ITEMS";

// 모든 ITEM 선택 해제 (전체선택 해제) (리스트의 ITEM 선택 해제)
export const DESELECT_ALL_ITEMS = "POST_DESELECT_ALL_ITEMS";

// 하나의 ITEM 의 더보기(more option) 활성화
export const TOGGLE_MORE_BUTTON = "POST_TOGGLE_MORE_BUTTON";

// 하나의 ITEM 의 상태 변경 더보기 활성화
export const TOGGLE_CHANGE_STATUS_BUTTON = "POST_TOGGLE_CHANGE_STATUS_BUTTON";

// 상태변경창 비활성화
export const CLOSE_CHANGE_STATUS_BUTTON = "POST_CLOSE_CHANGE_STATUS_BUTTON";

// 하나의 ITEM 상태 변경
export const UPDATE_ITEM = "POST_UPDATE_ITEM";

// 여러개의 ITEM 상태 변경
export const UPDATE_SELECTED_ITEMS = "POST_UPDATE_SELECTED_ITEMS";

// 여러개의 ITEM 삭제
export const DELETE_SELECTED_ITEMS = "POST_DELETE_SELECTED_ITEMS";

// 하나의 ITEM 삭제
export const DELETE_ITEM = "POST_DELETE_ITEM";

// 카테고리별 보기
export const FILTER_CATEGORY = "POST_FILTER_CATEGORY";

// 상태별 보기
export const FILTER_VISIBILITY = "POST_FILTER_VISIBILITY";
